/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询学籍列表接口
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<order.StudentStatusRes>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/order/student-status/list`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
